import SuccessIcon from 'components/Icons/SuccessIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Processed = () => {
  const { t } = useTranslation(['history', 'beneficiaries']);

  return (
    <div className="success-wrapper">
      <SuccessIcon />
      <span>{t('successful_import')}</span>
    </div>
  );
};
